export default class Currency {
    static toRepresentation(value) {
        return Math.round(value * 100);
    }
    static fromRepresentation(value) {
        return parseFloat((value / 100).toFixed(2));
    }
    static min(currency1, currency2) {
        return new Currency(Math.min(currency1.Value, currency2.Value), true);
    }
    /**
     *
     * @param from
     * @param isRepresentation default - false
     */
    constructor(from, isRepresentation = false) {
        if (from instanceof Currency) {
            this.value = from.Value;
        }
        else {
            this.value = isRepresentation ? from : Currency.toRepresentation(from);
        }
    }
    get Value() {
        return this.value;
    }
    get Representation() {
        return this.value;
    }
    new() {
        return new Currency(this);
    }
    add(curr) {
        return new Currency(curr.toNumber() + this.toNumber());
    }
    multiply(curr) {
        return new Currency(curr.toNumber() * this.toNumber());
    }
    roundToFullZloty() {
        return new Currency(Math.round(this.value / 100));
    }
    floor() {
        return new Currency(Math.floor(this.value / 100));
    }
    toNumber() {
        return Currency.fromRepresentation(this.value);
    }
    toString() {
        return String(this.toNumber());
    }
}
